export enum FactoryInvoicesSettingValue {
  STORE_BILLING_INFO_NAME = "57c9187d-7a1a-4c36-923c-d4b04ed1b097",
  STORE_BILLING_INFO_ADDRESS = "1851cbff-bcaa-4859-bad8-196b349f256a",
  STORE_BILLING_INFO_ADDITIONAL_ADDRESS = "efff8012-6a39-4947-a242-79e46e4c4536",
  STORE_BILLING_INFO_CITY = "e61d779e-39c7-4dd8-b8bd-3bbfd7452165",
  STORE_BILLING_INFO_STATE_REGION = "efaf56bf-37ba-44d2-9bb2-806636f2f3f7",
  STORE_BILLING_INFO_POSTAL_CODE = "d3acf142-8f16-4f9e-a34b-361e890e2ff6",
  STORE_BILLING_INFO_COUNTRY = "cc84495e-f2b1-496a-be00-ccbb9024f370",
}
